import config from "./config";
import { reactLocalStorage } from "reactjs-localstorage";

async function sendGuiDataEvent(data) {
try{
const guiDataEvent = {
    w_action: data.w_action,
    w_country:"ID",
    w_click_time: new Date().toISOString(),
    ref: document.referrer || "NA",
    operator_id:  "telkomsel_indonesia_Phase2_cubegames",
    ua: navigator.userAgent,
    w_host: window.location.hostname, 
    w_req_url: window.location.href,
    req_time: new Date().toISOString(), 
    ts: new Date().toISOString(),
    w_device: null,
    opt: "DPC_TSL",
    service: "cubegames",
    uid: reactLocalStorage.get("uid")
      ? reactLocalStorage.get("uid")
      :'NA' ,
    msisdn: reactLocalStorage.get("msisdn")
      ? reactLocalStorage.get("msisdn")
      :'NA' ,
    mtype:localStorage.getItem("mtype") || "",
    blocked : localStorage.getItem("blocked") || 0,
    breason : localStorage.getItem("breason") || "",
    sid:sessionStorage.getItem("sessionId") || "",
    campid : localStorage.getItem("camp") || sessionStorage.getItem("camp") || "",
    rcid: localStorage.getItem("rcid") || sessionStorage.getItem("rcid") || "",
  };
  let objData = { ...guiDataEvent,...data};
  var jsonData_base64 = window.btoa(JSON.stringify(objData)); //base_64
  let url = config.get("elastic_base_url");
    const response = await fetch(url, {
      method: "POST",
      headers: { "guiTopic": "waplogs","Content-Type": "application/json" },
      body: jsonData_base64,
      keepalive: true,
    });

    if (response.ok) {
      console.log("the data is:",data)
       console.log("resp>>>",response)
      return true;
    } else {
      console.log("API request failed with status:", response.status);
      return false;
    }
  } catch (error) {
    console.log("Error sending event:", error);
    return false;
  }
}

export function SendGuiDataEvents(data) {
  sendGuiDataEvent(data).then((success) => {
    if (success) {
      console.log("The event is send")
    } else {
      console.log("The event is not send") 
      
    }
  });
}


